// ═══════════════════════════════════════════════════════════════════════════════
//  src/components/onboarding/ObPaginacion.jsx
//  VOLVER ATRÁS, Y SABER DÓNDE SE ESTÁ
//
//  Rob, 24-09-2026: «también vi que no tenemos paginación para ir atrás hasta
//  el inicio o siguiente».
//
//  Tenía razón y era un agujero viejo: el lobby sí tenía «← Volver», pero en
//  cuanto empezaba el diagnóstico la única dirección era hacia adelante. Quien
//  se equivocaba en el paso 2 —o simplemente quería revisar qué había puesto—
//  no tenía más salida que recargar y empezar de cero.
//
//  ── LAS REGLAS DE NAVEGACIÓN ────────────────────────────────────────────────
//  · Se puede ir a cualquier paso ya contestado, y al siguiente pendiente. Ni
//    uno más: saltarse una pregunta dejaría el plan final hablando de datos que
//    el alumno nunca dio.
//  · La respuesta anterior sigue ahí al volver. Cada pantalla se inicializa con
//    lo que hay en el payload, así que volver a mirar no borra nada.
//  · La calibración, una vez hecha, deja de ser visitable. Repetirla
//    sobrescribiría la nota medida, y el documento maestro es explícito en que
//    el arco no se repite. Se ve marcada como hecha y no responde al clic.
//  · La última casilla es el plan: es la meta, no un sitio al que se navega.
//
//  Se dibuja una sola vez, en el orquestador, en vez de repetir un botón de
//  volver en cada una de las ocho pantallas — que es como se olvida en la
//  novena.
// ═══════════════════════════════════════════════════════════════════════════════

import { PASOS, TOTAL_PASOS, pasoRespondido, pasosAlcanzables } from './pasos';

export default function ObPaginacion({ pasoActual, payload, saltaCalibracion, onIr, onAtras }) {
    const alcanzables = pasosAlcanzables(payload, saltaCalibracion);

    const puedeIr = (id) => {
        if (id === pasoActual) return false;
        if (id === TOTAL_PASOS) return false;                  // el plan es la meta
        if (id === 7 && pasoRespondido(7, payload, saltaCalibracion)) return false;
        return alcanzables.includes(id);
    };

    return (
        <nav className="ob-paginacion" aria-label="Pasos del diagnóstico">
            <button type="button" className="ob-pag-atras" onClick={onAtras}>
                ← Atrás
            </button>

            <ol className="ob-pag-puntos">
                {PASOS.map((paso) => {
                    const hecho = pasoRespondido(paso.id, payload, saltaCalibracion);
                    const aqui = paso.id === pasoActual;
                    const clases = [
                        'ob-pag-punto',
                        aqui ? 'aqui' : '',
                        hecho && !aqui ? 'hecho' : '',
                    ].filter(Boolean).join(' ');

                    return (
                        <li key={paso.id}>
                            <button
                                type="button"
                                className={clases}
                                data-prueba={`paso-${paso.id}`}
                                disabled={!puedeIr(paso.id)}
                                aria-current={aqui ? 'step' : undefined}
                                onClick={() => onIr(paso.id)}
                                title={aqui ? `Estás aquí: ${paso.nombre}` : paso.nombre}
                            >
                                {paso.id}
                            </button>
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
